module.exports = __webpack_public_path__ + "static/media/pla_white_strew2.5a8e29c5.png";